// extracted by mini-css-extract-plugin
export var container = "_u2-0";
export var table = "_u2-2";
export var tableWrapper = "_u2-1";